export const paylines = {
    1: [0, 0, 0, 0, 0],
    2: [1, 1, 1, 1, 1],
    3: [2, 2, 2, 2, 2],
    4: [0, 1, 2, 1, 0],
    5: [2, 1, 0, 1, 2],
    6: [0, 0, 1, 2, 2],
    7: [2, 2, 1, 0, 0],
    8: [1, 0, 1, 2, 1],
    9: [1, 2, 1, 0, 1],
    10: [0, 1, 1, 1, 2],
    11: [2, 1, 1, 1, 0],
    12: [0, 1, 0, 1, 2],
    13: [2, 1, 2, 1, 0],
    14: [1, 1, 0, 1, 1],
    15: [1, 1, 2, 1, 1],
    16: [0, 2, 1, 0, 2],
    17: [2, 0, 1, 2, 0],
    18: [0, 0, 2, 0, 0],
    19: [2, 2, 0, 2, 2],
    20: [1, 0, 0, 0, 1],
};

export type Paylines = (keyof typeof paylines)[];
